
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.458 5.59a.5.5 0 000-.71L11.93 2.378a.5.5 0 00-.851.355v1.79H5.915a3.916 3.916 0 000 7.832H9.12a.712.712 0 000-1.424H5.916a2.492 2.492 0 010-4.984h5.162v1.79a.5.5 0 00.852.355l2.528-2.502z","fill":"#282E3E"}})])
          )
        }
      }
    